import { render, staticRenderFns } from "./egrainInfo.vue?vue&type=template&id=eaff2dac&"
import script from "./egrainInfo.vue?vue&type=script&lang=js&"
export * from "./egrainInfo.vue?vue&type=script&lang=js&"
import style0 from "./egrainInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports